import React from 'react';
import { bookData } from '../../data/mock';
import { StarRating } from './StarRating';

const OfficialReviewCard = ({ review }) => (
  <div
    key={review.id}
    className="review-card bg-bg-card p-10 rounded-lg border-2 border-brand-primary mb-8"
  >
    <div className="mb-4">
      <span className="inline-block px-4 py-1 bg-brand-primary text-text-inverse text-sm font-semibold rounded-full">
        Recensione Ufficiale
      </span>
    </div>

    <div className="flex items-center gap-2 mb-6">
      <StarRating rating={review.rating} />
    </div>

    <p className="body-medium text-text-secondary mb-8 leading-relaxed italic text-justify">
      "{review.text}"
    </p>

    <div className="flex items-center gap-3 pt-6 border-t border-border-medium">
      <div className="w-14 h-14 rounded-full bg-secondary-olive flex items-center justify-center">
        <span className="text-3xl">📖</span>
      </div>
      <div>
        <p className="body-medium text-text-primary font-semibold">{review.name}</p>
        <p className="body-small text-text-secondary">Casa Editrice</p>
      </div>
    </div>
  </div>
);

const AmazonRankingCard = () => (
  <div className="review-card bg-bg-card p-8 rounded-lg border-2 border-brand-primary mb-8">
    <div className="mb-4">
      <span className="inline-block px-4 py-1 bg-brand-primary text-text-inverse text-sm font-semibold rounded-full">
        Classifica Amazon
      </span>
    </div>
    <h3 className="heading-5 text-brand-primary mb-4">Novità letterarie più interessanti</h3>
    <img
      src="/amazon-classifica.jpg"
      alt="Classifica Amazon - Novità letterarie più interessanti"
      className="w-full h-auto rounded-lg border border-border-medium cursor-pointer hover:border-brand-primary transition-all"
      onClick={() => window.open('/amazon-classifica.jpg', '_blank')}
    />
  </div>
);

const TeleBariVideoCard = () => (
  <div className="review-card bg-bg-card p-8 rounded-lg border-2 border-brand-primary">
    <div className="mb-4">
      <span className="inline-block px-4 py-1 bg-brand-primary text-text-inverse text-sm font-semibold rounded-full">
        Video TeleBari
      </span>
    </div>
    <h3 className="heading-5 text-brand-primary mb-4">Servizio giornalistico sul libro</h3>
    <video controls className="w-full h-auto rounded-lg">
      <source src="/telebari-video.mp4" type="video/mp4" />
      Il tuo browser non supporta la riproduzione video.
    </video>
  </div>
);

export const RecensioniTab = () => (
  <div className="max-w-3xl mx-auto">
    {bookData.reviews.map((review) => (
      <OfficialReviewCard key={review.id} review={review} />
    ))}
    <AmazonRankingCard />
    <TeleBariVideoCard />
  </div>
);
